const factors = [
  { title: 'Ответственность', desc: 'Одним нравится отвечать за результат, другие предпочитают работать в рамках чётких поручений.' },
  { title: 'Признание', desc: 'Кому-то важно публичное признание, кому-то достаточно личной благодарности руководителя.' },
  { title: 'Сложные задачи', desc: 'Одни ищут вызов, другие более эффективны в стабильных и понятных процессах.' },
  { title: 'Развитие', desc: 'Для части сотрудников рост — главный мотиватор, для других важнее стабильность текущей роли.' },
  { title: 'Автономность', desc: 'Кому-то нужна свобода действий, кому-то — понятная структура и регулярная поддержка.' },
  { title: 'Материальное вознаграждение', desc: 'Значимость денег и предпочтительная форма поощрения у сотрудников различаются.' },
  { title: 'Публичная оценка', desc: 'Не всем комфортно быть в центре внимания, даже если оценка позитивная.' },
  { title: 'Обучение', desc: 'Одни ценят возможность учиться, другие предпочитают учиться через практику в работе.' },
  { title: 'Карьерные возможности', desc: 'Для кого-то важен карьерный рост, для кого-то — углубление экспертизы без смены должности.' },
];

export default function DifferentMotivation() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Почему один подход к мотивации не работает для всей команды
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Сотрудники по-разному реагируют на одни и те же стимулы. Задача руководителя — понимать конкретного человека и при этом сохранять единые правила
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {factors.map((f) => (
            <div key={f.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <h3 className="font-bold text-gray-900 text-sm mb-2">{f.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-4xl mx-auto text-center">
          <p className="text-base text-teal-800 leading-relaxed font-semibold">
            Задача руководителя — понимать конкретного сотрудника и при этом сохранять единые правила и стандарты для команды. Индивидуальный подход к людям не должен превращаться в двойные стандарты.
          </p>
        </div>
      </div>
    </section>
  );
}